import { render, staticRenderFns } from "./SkillSave.vue?vue&type=template&id=1e619e1c&scoped=true"
import script from "./SkillSave.vue?vue&type=script&lang=js"
export * from "./SkillSave.vue?vue&type=script&lang=js"
import style0 from "./SkillSave.vue?vue&type=style&index=0&id=1e619e1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e619e1c",
  null
  
)

export default component.exports